import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const useFormatDate = () => {
  const { i18n } = useTranslation();

  return {
    formatDate: useCallback(
      (
        value: Date | string | number | null | undefined,
        format: "datetime" | "date" | "time" = "datetime"
      ) => {
        if (!value) return "";

        const date = value instanceof Date ? value : new Date(value);
        if (Number.isNaN(date.getTime())) return "";

        const locale = i18n.language || "en";

        switch (format) {
          case "date":
            // 17/02/2025
            return new Intl.DateTimeFormat(locale, {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
            }).format(date);

          case "time":
            // 16:45:03
            return new Intl.DateTimeFormat(locale, {
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false,
            }).format(date);

          case "datetime":
            // "17/02/2025, 16:45:03"
            return new Intl.DateTimeFormat(locale, {
              day: "2-digit",
              month: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: false,
            }).format(date);
        }
      },
      [i18n.language]
    ),
  };
};
